// extracted by mini-css-extract-plugin
export var searchHeader = "_6d-0";
export var searchHeaderDark = "_6d-1";